import DatePicker from 'react-datepicker'
import { DateTime } from 'luxon'

import useDateSelectWithDeadlines from '@hooks/useDateSelectWithDeadlines'

import type { ProviderModel } from '@models/types'

import 'react-datepicker/dist/react-datepicker.css'

interface DateSelectFieldWithDeadlinesProps {
  callbacks: {
    onChange: (formattedDate: string, dateObj: DateTime) => void,
  },
  dateFormat?: string,
  disabled?: boolean,
  minDate?: DateTime,
  provider: ProviderModel,
  serviceId: number,
  value?: DateTime,
  valueFormat?: string,
}

const DateSelectFieldWithDeadlines = (props: DateSelectFieldWithDeadlinesProps) => {
  const {
    callbacks: {
      onChange,
    },
    dateFormat = 'dd/MM/yyyy',
    disabled = false,
    minDate = DateTime.now(),
    provider,
    serviceId,
    value,
    valueFormat = 'yyyy-MM-dd',
  } = props

  const dateSelectWithDeadlines = useDateSelectWithDeadlines({ convertToJsDate: true, provider, serviceId })
  const {
    excludeDates,
    hasPassedDeadlineTime,
    maxDateObj,
    tomorrow,
  } = dateSelectWithDeadlines

  const valueDateObj = !!value && typeof value === 'string'
    ? DateTime.fromFormat(value, valueFormat).toJSDate()
    : value

  return (
    <DatePicker
      dateFormat={dateFormat}
      disabled={disabled}
      // @ts-expect-error TS2322
      excludeDates={hasPassedDeadlineTime ? [...excludeDates, tomorrow] : excludeDates}
      // @ts-expect-error TS2322
      maxDate={maxDateObj}
      minDate={minDate ? minDate.toJSDate() : undefined}
      // @ts-expect-error TS2322
      onChange={(date: Date) => {
        const dateObj = DateTime.fromJSDate(date)
        onChange(dateObj.toFormat(valueFormat), dateObj)
      }}
      // @ts-expect-error TS2322
      selected={valueDateObj}
    />
  )
}

export default DateSelectFieldWithDeadlines
